const BASE_URL: string = '/invoice';

/**
 * 
 */
 export const BILL_PATH = {
  BILL: BASE_URL,
}